import React, { useState } from 'react';
import { useSelector,connect } from 'react-redux';
import { object } from 'prop-types';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import { withRouter } from 'react-router';
import * as classes from './BobActionMenu.module.css';

const BobActionMenu = ({
    currentUser,
    ...props
}) => {

    const companyApplications = useSelector(
        ({ bob }) => bob.companyApplications
    );
    
    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const handleRenameBasAgent = () => {
        props.setRenameAgentModalOpen(true);
        setMenuOpen(false);
    };

    const handlePingBasAgent = () => {
        props.handlePingAgent();
        setMenuOpen(false);
    };

    const handleRebootBasAgent = () => {
        props.handleRebootAgent();
        setMenuOpen(false);
    };

    const handleAssignBasAgent = () => {
        props.setAssignAgentModalOpen(true);
        setMenuOpen(false);
    };

    const handleDeleteBasAgent = () => {
        props.setDeleteAgentModalOpen(true);
        setMenuOpen(false);
    };

    const handleRestartBasAgent = () => {
        props.handleRestartApplication();
        setMenuOpen(false);
    };

    const handleConfigureBasAgent = () => {
        props.handleConfigureAgent();
        setMenuOpen(false);
    };

    const handleExportFormattedTable = () => {
        props.handleExportGrid();
        setMenuOpen(false);
    };

    const handleExport = () => {
        props.handleExport();
        setMenuOpen(false);
    };

    const handleExportTimeseries = () => {
        props.handleExportTimeseries();
        setMenuOpen(false);
    };

    const handleApplyToAll = () => {
        props.applyToAll();
        setMenuOpen(false);
    };

    const renderMenu = () => {
        if (props.type === 'OptimizationReport') {
            return <Paper className={classes.BobActionMenu}>
                <Button onClick={handleApplyToAll}>
                    {` Apply To All ${props.entityType}`}
                </Button>
            </Paper>;
        } else if (props.type === 'Roles') {
            return <Paper className={classes.BobActionMenu}>
                <Button onClick={props.handleAddNewRole}>
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        add
                    </span>
                    Add New Role
                </Button>
                <Button onClick={(e) => props.handleRoleStatusChange('Inactive')}>
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        do_not_disturb_on
                    </span>
                    Disable a Role
                </Button>
            </Paper>;
        } else if (props.type === 'ServiceManagement') {
            return <Paper className={classes.BobActionMenu}>
                <Button>
                    <i className={`fa fa-check ${classes.menuItemIcon}`} />
                    Approve
                </Button>
                <Button>
                    <img
                        alt=""
                        className={classes.menuItemIcon}
                        src="/assets/images/deleteIconColor.svg"
                    />
                    Decline
                </Button>
                <Button
                    onClick={props.handleCreateServiceRequest}
                >
                    <i className={`fas fa-edit ${classes.menuItemIcon}`} />
                    New Service Request
                </Button>
            </Paper>;
        } else if (props.type === 'Users') {
            return <Paper className={classes.BobActionMenu}>
                { process.env.allowCreateUser ? 
                    <Button
                        onClick={props.handleCreateNewUser}
                        disabled={!currentUser.isSuperUser}
                    >
                        <i className={`fas fa-edit ${classes.menuItemIcon}`} />
                        Add New User
                    </Button>
                    : null}
                <Button>
                    <i className={`fas fa-minus-circle ${classes.menuItemIcon}`} />
                    Disable Account
                </Button>
            </Paper>;
        }
        else if (props.type === 'Announcements') {
            return <Paper className={classes.BobActionMenu}>
                <Button
                    className={classes.Font12}
                    onClick={props.handleCreateAnnouncements}
                >
                    <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                    New Release Notes
                </Button>
                {/*<Button
                    className={classes.Font12}
                    onClick={props.setAsActive}
                >
              
                    <i className={`fas fa-file-import ${classes.menuItemIcon}`} />
                    Set as Active
                </Button>
                <Button  className={classes.Font12} onClick={props.setAsInActive}>
                    <i className={`fas fa-file-export ${classes.menuItemIcon}`} />
                    Set as Inactive
                </Button>
                */}
                {props.deleteFl ?
                    <Button className={classes.Font12} onClick={props.handleDelete}>
                        <i className={`fas fa-trash-alt ${classes.menuItemIcon}`} />

                        Delete
                    </Button>
                    : ''}
            </Paper>;
        }
        else if (props.type === 'Reporting') {
            return <Paper className={classes.BobActionMenu}>
                <Button
                    className={classes.Font12}
                    onClick={props.handleCreateReport}
                >
                    <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                    New Report
                </Button>
            </Paper>;
        }
        else if (props.type === 'BackgroundJobs') {
            return <Paper className={classes.BobActionMenu}>
                {/* <Button
                    className={classes.Font12}
                    onClick={props.handleCreateAnnouncements}
                >
                    <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                    New Release Notes
                </Button> 
               */}
                {/*<Button
                    className={classes.Font12}
                    onClick={props.setAsActive}
                >
              
                    <i className={`fas fa-file-import ${classes.menuItemIcon}`} />
                    Set as Active
                </Button>
                <Button  className={classes.Font12} onClick={props.setAsInActive}>
                    <i className={`fas fa-file-export ${classes.menuItemIcon}`} />
                    Set as Inactive
                </Button>
                */}
                <Button className={classes.Font12} onClick={props.handleDelete}>
                    <i className={`fas fa-trash-alt ${classes.menuItemIcon}`} />

                    Delete
                </Button>
            </Paper>;
        } else if (props.type === 'CompanyManagement') {
            return <Paper className={classes.BobActionMenu}>
                <Button
                    onClick={props.handleCreateCompany}
                >
                    <i className={`fas fa-edit ${classes.menuItemIcon}`} />
                    Create
                </Button>
                <Button
                    onClick={() => props.handleEnableOrDisable('ActionMenu', 'Enable')}
                >
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        check_circle
                    </span>
                    Enable
                </Button>
                <Button
                    onClick={() => props.handleEnableOrDisable('ActionMenu', 'Disable')}
                >
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        do_not_disturb_on
                    </span>
                    Disable
                </Button>
            </Paper>;
        } else if (props.type === 'Conversions') {
            return <Paper className={classes.BobActionMenu}>
                <Button
                    onClick={() => props.handleResetConversion()}
                >
                    <i className={`fas fa-redo ${classes.menuItemIcon}`} />
                    Reset
                </Button>
                {
                    props.isK2aConversion ?
                        null
                        :
                        <Button
                            onClick={() => props.handleDeleteConversion()}
                        >
                            <i className={`fas fa-trash-alt ${classes.menuItemIcon}`} />
                            Delete Conversion
                        </Button>
                }
            </Paper>;
        } else if ( props.type === 'RuleList') {
            return <Paper className={classes.BobActionMenu}>
                <Button
                    onClick={() => props.handleListAction('addRule')}
                >
                    <i className={`fas fa-edit ${classes.menuItemIcon}`} />
                    Add Rule
                </Button>
                {
                    process.env.formulaBuilderEnabled ?
                        <Button
                            onClick={() => props.handleListAction('createRule')}
                        >
                            <i className={`fas fa-edit ${classes.menuItemIcon}`} />
                            Create Rule
                        </Button>
                        :
                        null
                }
                {/* <Button
                    onClick={()=> props.handleListAction('duplicate')}
                    disabled={props.isDisableRuleListMenu}
                >
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        content_copy
                    </span>
                    Duplicate
                </Button>
                <Button
                    onClick={()=> props.handleListAction('enable')}
                    disabled={props.isDisableRuleListMenu}
                >
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        check_circle
                    </span>
                    Enable
                </Button>
                <Button
                    onClick={() => props.handleListAction('disable')}
                    disabled={props.isDisableRuleListMenu}
                >
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        do_not_disturb_on
                    </span>
                    Disable
                </Button>
                <Button
                    onClick={() => props.handleListAction('delete')}
                    disabled={props.isDisableRuleListMenu}
                >
                    <span className={`material-icons-outlined material-icon-size ${classes.menuItemIcon}`}>
                        delete
                    </span>
                    Delete
                </Button> */}
            </Paper>;
        }
        else if (props.type === 'UserViewConfiguration') {
            return <Paper className={classes.BobActionMenu}>
                <Button
                    onClick={props.handleDeleteConfigurations}
                >
                    <i className={`fas fa-trash-alt ${classes.menuItemIcon}`} />
                    Delete
                </Button>
            </Paper>;
        }
        else {
            return <Paper className={props.activeTab === 'AgentActions' ? classes.BobAgentActionsMenu : classes.BobActionMenu}>
                {
                    props.activeTab === 'EquipmentSensors' || props.activeTab === 'EquipmentFaults' || props.activeTab === 'EquipmentScores' || props.activeTab === 'EquipmentRules' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateSensor}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Add New Sensor
                            </Button>
                            {process.env.customCalculationEnabled?
                                <Button
                                    onClick={props.handleCalculatedSensor}
                                >
                                    <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                    Add New Calculated Sensor
                                </Button>
                                :''}
                            <Button
                                onClick={props.handleCreateSubscription}
                            >
                                <i className={`fas fa-bell ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Alerts
                            </Button>
                        </React.Fragment>
                        :
                        ''
                }
                {
                    props.activeTab === 'SystemSensors' || props.activeTab === 'SystemFaults' || props.activeTab === 'SystemScores' || props.activeTab === 'SystemRules' || props.activeTab === 'SystemEquipment' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateSensor}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Add New Sensor
                            </Button>
                            {process.env.customCalculationEnabled ?
                                <Button
                                    onClick={props.handleCalculatedSensor}
                                >
                                    <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                    Add New Calculated Sensor
                                </Button>
                                : ''}
                            <Button
                                onClick={props.handleCreateSubscription}
                            >
                                <i className={`fas fa-bell ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Alerts
                            </Button>
                        </React.Fragment>
                        :
                        ''
                }
                {
                    props.activeTab === 'Client' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateClient}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create Client
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToCompany}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Company
                            </Button>
                            <Button
                                onClick={() => handleExportFormattedTable()}
                            >
                                <img
                                    alt=""
                                    className={classes.menuItemIcon}
                                    src="/assets/images/download.svg"
                                />
                                Export Formatted Table
                            </Button>
                        </React.Fragment>
                        :
                        ''
                }
                {
                    props.activeTab === 'CompanyClient' || props.activeTab === 'Clients' ?
                        <Button
                            onClick={props.handleCreateClient}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            Create Client
                        </Button>
                        :
                        ''
                }
                {
                    props.activeTab === 'Site' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateSite}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create Site
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToCompany}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Company
                            </Button>
                        </React.Fragment>
                        : ''

                }
                {
                    props.activeTab === 'ClientSites' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateSite}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create Site
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToCampus}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Campus
                            </Button>
                        </React.Fragment> : ''
                }
                {
                    props.activeTab === 'Equipment' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateEquipment}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create Equipment
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToCompany}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Company
                            </Button>
                        </React.Fragment>
                        : ''
                }
                {
                    props.activeTab === 'ClientEquipment' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateEquipment}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create Equipment
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToCampus}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Campus
                            </Button>
                        </React.Fragment> : ''
                }
                {
                    props.activeTab === 'SiteEquipment' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateEquipment}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create Equipment
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToArea}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Area
                            </Button>
                            <Button
                                onClick={props.handlePreviewWeatherData}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Preview Weather Data
                            </Button>
                        </React.Fragment> : ''
                }
                {
                    props.activeTab === 'System' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateSystem}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create System
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToCompany}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Company
                            </Button>
                        </React.Fragment>
                        : ''
                }
                {
                    props.activeTab === 'ClientSystems' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateSystem}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create System
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToCampus}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Campus
                            </Button>
                        </React.Fragment> : ''
                }
                {
                    props.activeTab === 'SiteSystems' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleCreateSystem}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Create System
                            </Button>
                            <Button
                                onClick={props.handleSubscribeToArea}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Area
                            </Button>
                            <Button
                                onClick={props.handlePreviewWeatherData}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Preview Weather Data
                            </Button>
                        </React.Fragment> : ''
                }
                {
                    props.activeTab === 'SiteScore' ?
                        <React.Fragment>
                            <Button
                                onClick={props.handleSubscribeToArea}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Subscribe to Area
                            </Button>
                            <Button
                                onClick={props.handlePreviewWeatherData}
                            >
                                <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                                Preview Weather Data
                            </Button>
                        </React.Fragment>
                        :
                        ''
                }
                {
                    props.activeTab === 'EquipmentFaults' && companyApplications.includes('Service') ?
                        <Button
                            onClick={props.handleCreateServiceRequest}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            New Service Request
                        </Button> : ''
                }
                {
                    props.activeTab === 'FSM Integrations' ?
                        <Button
                            onClick={() => props.setCreateFsmAgentModalOpen(true)}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            New FSM Integration
                        </Button> : ''
                }
                {
                    props.activeTab === 'Bas Agents' ?
                        <Button
                            onClick={() => props.setCreateBasAgentModalOpen(true)}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            New Agent
                        </Button> : ''
                }
                {
                    props.activeTab === 'AgentActions' ?
                        <React.Fragment>
                            <Button
                                onClick={() => handleConfigureBasAgent()}
                            >
                                <i className={`fas fa-cog ${classes.menuItemIcon}`} aria-hidden="true" />
                                Configure BAS Network
                            </Button>
                            <Button
                                onClick={() => handleRenameBasAgent()}
                            >
                                <i className={`fas fa-edit ${classes.menuItemIcon}`} aria-hidden="true" />
                                Rename Agent
                            </Button>
                            <Button
                                onClick={props.handleCreateSubscription}
                            >
                                <i className={`fas fa-clock ${classes.menuItemIcon}`} aria-hidden="true" />
                                Update Agent Time Zone
                            </Button>
                            <Button
                                onClick={() => handlePingBasAgent()}
                            >
                                <i className={`far fa-bell ${classes.menuItemIcon}`} aria-hidden="true" />
                                Ping Agent
                            </Button>
                            <Button
                                onClick={() => handleRebootBasAgent()}
                            >
                                <i className={`fas fa-power-off ${classes.menuItemIcon}`} aria-hidden="true" />
                                Reboot Agent
                            </Button>
                            <Button
                                onClick={() => handleAssignBasAgent()}
                            >
                                <i className={`fas fa-link ${classes.menuItemIcon}`} aria-hidden="true" />
                                Assign Agent
                            </Button>
                            <Button
                                onClick={() => handleDeleteBasAgent()}
                            >
                                <i className={`fas fa-trash ${classes.menuItemIcon}`} aria-hidden="true" />
                                Delete Agent
                            </Button>
                            <Button
                                onClick={() => handleRestartBasAgent()}
                            >
                                <i className={`fas fa-history ${classes.menuItemIcon}`} aria-hidden="true" />
                                Restart Application
                            </Button>
                        </React.Fragment>
                        :
                        ''
                }
                {
                    props.activeTab === 'ClientHealth Monitor' ?
                        <Button
                            onClick={props.handleSubscribeToCampus}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            Subscribe to Campus
                        </Button>
                        :
                        ''
                }
                {
                    props.activeTab === 'Health Monitor' ?
                        <Button
                            onClick={props.handleSubscribeToCompany}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            Subscribe to Company
                        </Button>
                        :
                        ''
                }
                {
                    props.isSchedule ?
                        <Button
                            onClick={props.handleCreateAppointment}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            New Service Request
                        </Button> : ''
                }
                {/* {
                    props.activeTab === 'CompanySchedule' && process.env.schedulerEnabled ?
                        <Button
                            onClick={props.handleCreateServiceCall}
                        >
                            <i className={`fa fa-plus ${classes.menuItemIcon}`} aria-hidden="true" />
                            New Service Call
                        </Button> : ''
                } */}
                {
                    props.isExport ?
                        <Button
                            onClick={handleExport}
                            disabled={props.isDisableExport}
                        >
                            <img
                                alt=""
                                className={classes.menuItemIcon}
                                src="/assets/images/download.svg"
                            />
                            { props.view === 'sensorgrid' || props.view === 'scoregrid' ? 'Export Raw Data':'Export'}
                        </Button> : '' 
                }
                {
                    props.isHealthMonitor ?
                        <Button
                            onClick={props.handleHealthMonitorExport}
                            disabled={props.isDisableExport}
                        >
                            <img
                                alt=""
                                className={classes.menuItemIcon}
                                src="/assets/images/download.svg"
                            />
                            Export View
                        </Button> : '' 
                }
                {
                    props.isHealthMonitor ?
                        <Button
                            onClick={props.healthMonitorRawDataExport}
                            disabled={props.isDisableExport}
                        >
                            <img
                                alt=""
                                className={classes.menuItemIcon}
                                src="/assets/images/download.svg"
                            />
                            Export Raw Data
                        </Button> : '' 
                }
                {
                    props.view === 'sensorgrid' || props.view === 'scoregrid' || props.activeTab === 'SiteEquipment' || props.activeTab === 'SiteFaults' ?
                        <Button
                            onClick={() => handleExportFormattedTable()}
                            disabled={props.isDisableExport}
                        >
                            <img
                                alt=""
                                className={classes.menuItemIcon}
                                src="/assets/images/download.svg"
                            />
                            Export Formatted Table
                        </Button> : '' 
                }
                {
                    props.isExportTimeseries && process.env.isExportTimeSeriesEnabled ?
                        <Button
                            onClick={() => handleExportTimeseries()}
                        >
                            <img
                                alt=""
                                className={classes.menuItemIcon}
                                src="/assets/images/download.svg"
                            />
                            Export Timeseries
                        </Button> : '' 
                }
                {
                    props.view === 'rawdata' ?
                        <Button
                            onClick={() => handleExportFormattedTable()}
                            disabled={props.isDisableExport}
                        >
                            <img
                                alt=""
                                className={classes.menuItemIcon}
                                src="/assets/images/download.svg"
                            />
                            Export Formatted Table
                        </Button> : '' 
                }
                {
                    // eslint-disable-next-line no-constant-condition
                    props.view === 'sensorgraph' || props.view === 'scoregraph' ?
                        <Button
                            disabled={props.isDisableExport}
                            onClick={props.handleImageDownload}
                        >
                            <img
                                alt=""
                                className={classes.menuItemIcon}
                                src="/assets/images/download.svg"
                            />
                            Download Graph
                        </Button> : '' 
                }
                
            </Paper>; 
        }
    };
    
    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div>
                <React.Fragment>
                    {props.type === 'Announcements' || props.type ==='BackgroundJobs' ?
                        <Button
                            onClick={handleToggle}
                            className={`action-dropdown ${menuOpen ? classes.BobActionButtonActive : classes.BobActionButton}`}
                        >
                            Actions
                            <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                        </Button>:
                        <Button
                            onClick={handleToggle}
                            className={ menuOpen ? classes.BobActionButtonActive : classes.BobActionButton}
                        >
                            Actions
                            <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                        </Button>}
                    { menuOpen ? renderMenu() : null }
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

BobActionMenu.defaultProps = {
    currentUser: {}
};

BobActionMenu.propTypes = {
    currentUser: object
};

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser
    };
};

export default withRouter(connect(mapStateToProps, null)(BobActionMenu));
